/**
 * @param topic
 * @param payload
 * @param origin
 * @param target
 */
/**
 * @param topic
 * @param payload
 * @param origin
 * @param target
 */ export function postMessage(topic, payload, origin = "*", target = window) {
    payload = JSON.stringify(payload);
    target.postMessage({
        topic,
        payload
    }, origin);
}
/**
 * @param topic
 * @param callback
 * @returns {(event:{data: {topic: any, payload: any}})=>undefined}
 */
export function addCrossDomainEventListener(topic, callback) {
    const listener = (event) => {
        if (!event || !event.data || !event.data.topic || event.data.topic != topic) {
            return;
        }
        let payload = event.data.payload;
        if (undefined === payload) {
            payload = null;
        }
        callback(payload ? typeof payload === "string" ? JSON.parse(payload) : payload : {});
    };
    const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, listener, false);
    return listener;
}
/**
 * @param listener
 */
export function removeCrossDomainEventListener(listener) {
    const eventMethod = window.removeEventListener ? "removeEventListener" : "detachEvent";
    const eventer = window[eventMethod];
    const messageEvent = eventMethod == "detachEvent" ? "onmessage" : "message";
    eventer(messageEvent, listener, false);
}
export class Channel {
    /**
     * @param origin
     * @param target
     * @param debug
     */
    constructor(origin, target = window, debug = false) {
        this.origin = origin;
        this.target = target;
        this.debug = debug;
        this.debugListenres = [];
    }
    /**
     * @param topic
     * @param callback
     * @returns {Function}
     */
    subscribe(topic, callback) {
        if (this.debug) {
            console.log(`Subscribing to "${topic}" ...`);
            this.debugListenres.push(addCrossDomainEventListener(topic, (payload) => {
                console.log(`Received message for topic "${topic}" and payload: `, payload);
            }));
        }
        return addCrossDomainEventListener(topic, callback);
    }
    /**
     * @param listener
     */
    unsuscribe(listener) {
        return removeCrossDomainEventListener(listener);
    }
    /**
     * @param topic
     * @param payload
     */
    send(topic, payload) {
        if (this.debug) {
            console.log(`Sending message for "${topic}" with payload: `, payload);
        }
        return postMessage(topic, payload, this.origin, this.target);
    }
}
